import { LayoutDashboard, Footprints } from 'lucide-react'

export type ExperienceMode = 'classic' | 'guided'

const EXPERIENCE_MODES: { id: ExperienceMode; label: string; icon: typeof LayoutDashboard }[] = [
  { id: 'classic', label: 'Classic', icon: LayoutDashboard },
  { id: 'guided', label: 'Guided', icon: Footprints },
]

interface ExperienceModeSwitcherProps {
  mode: ExperienceMode
  onChange: (mode: ExperienceMode) => void
}

export function ExperienceModeSwitcher({ mode, onChange }: ExperienceModeSwitcherProps) {
  const options = EXPERIENCE_MODES
  return (
    <div className="flex items-center gap-1 p-1 rounded-[10px] w-fit" style={{ background: '#f8fafc', border: '1px solid #e5e7eb' }}>
      {options.map(({ id, label, icon: Icon }) => (
        <button
          key={id}
          onClick={() => onChange(id)}
          className="flex items-center gap-1.5 px-3 py-1.5 rounded-[7px] text-[11px] font-semibold transition-colors"
          style={mode === id
            ? { background: '#4f46e5', color: '#ffffff' }
            : { background: 'transparent', color: '#64748b' }
          }
        >
          <Icon size={12} /> {label}
        </button>
      ))}
    </div>
  )
}
